import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mappedRecommendationData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateRecommendationMutation = (
	creditReviewId: string,
	refetchRecommendationInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
			setActionFormState,
		}: {
			formValues: { [key: string]: any };
			setActionFormState: Function;
		}) => {
			return creditReviewDetailsService.updateRecommendationInfo(
				creditReviewId,
				mappedRecommendationData(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				refetchRecommendationInfo();
				setActionFormState(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateRecommendationMutation;
